import { createSvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

const IconBase = createSvgIcon(
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.36698 9.05986L16.1261 16.7318L14.3628 4.34925C11.046 4.64956 8.16218 6.4454 6.36698 9.05986Z"
      className="slice-fill"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.31264 9.26069L16.2431 16.9774L14.5238 4.29152C15.0074 4.23116 15.5001 4.20007 16 4.20007C22.517 4.20007 27.8 9.48311 27.8 16.0001C27.8 22.517 22.517 27.8001 16 27.8001C9.48305 27.8001 4.20001 22.517 4.20001 16.0001C4.20001 13.4945 4.98092 11.1714 6.31264 9.26069Z"
      fill="currentColor"
      className="alt-slice-fill"
    />
  </svg>,
  'PieChartIcon'
);

export const PieChartIcon = (props: SvgIconProps) => {
  return (
    <IconBase
      {...props}
      sx={(theme) => ({
        '.slice-fill': {
          color: theme.palette.status.success.main,
        },
        '.alt-slice-fill': {
          color: theme.palette.status.success.highContrast,
        },
      })}
    />
  );
};
